import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from '@mui/x-data-grid-premium'

export function ActionItem({
  clickHandler,
  ...props
}: GridActionsCellItemProps & { clickHandler: () => void }) {
  return <GridActionsCellItem {...props} onClick={() => clickHandler()} />
}
